<template>
  <v-dialog
    :value="value"
    width="500"
    @input="handleInput"
  >
    <v-form @submit.prevent.stop="submit">
      <v-card>
        <v-toolbar
          flat
          dark
          color="primary"
        >
          {{ $t('Import') }}
          <v-spacer />
          <v-btn
            icon
            dark
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div class="mb-2">
            <p class="mb-1">
              {{ $t('Use this CSV template to add your questions and answers.') }}
            </p>

            <a href="/assets/webcomet_csv_import_template.csv">
              webcomet_csv_import_template.csv
            </a>
          </div>

          <v-file-input
            v-model="form.file"
            :disabled="form.processing"
            :loading="form.processing"
            :label="$t('Select file')"
            truncate-length="15"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="$emit('input', false)"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            type="submit"
            :loading="form.processing"
            :disabled="form.processing"
          >
            {{ $t('Import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    faqId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        file: null,
      }),
    }
  },

  methods: {
    submit() {
      const url = this.route('faq.import-csv.store', this.faqId);

      this.form.post(url.toString(), {
        onSuccess: () => {
          this.$emit('input', false);
          this.$emit('success');
        }
      });
    },

    handleInput(value) {
      this.$emit('input', value);

      if (value === false) {
        this.$nextTick(() => {
          this.form.reset();
          this.form.clearErrors();
        });
      }
    }
  }
}
</script>